import React from 'react';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import style from './FullInfoBtn.module.scss';

interface IProps {
	onClick: () => void;
}

export const FullInfoBtn: React.FC<IProps> = ({ onClick }) => {
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<Button className={style.btn} disabled={!hasAccess} onClick={onClick}>
			<Text translationKey="fullInfoButton" translationNameSpace="listing" asFragment={true} />
		</Button>
	);
};
